import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import parse from "html-react-parser";
import { api, getTicketTypeInfosByTicketTypeId } from "ticketino-api-client";

import Header from "./components/Header";

import { ReactComponent as IconAlert } from '../images/icon/icon-alert.svg';

const Visitor_Step40_Checkout = () => {
    const [organizerId, setOrganizerId] = useState(0);

    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();

    const [tickets, setTickets] = useState([]);

    const [ticketType, setTicketType] = useState({});
    const [ticketTypeId, setTicketTypeId] = useState(0);

    const [promotionCode, setPromotionCode] = useState("");
    const [promotionError, setPromotionError] = useState({
        text: "",
        valid: false
    });
    const [addedPromotionCodes, setAddedPromotionCodes] = useState([]);
    const [showPromotionInput, setShowPromotionInput] = useState(false);
    const [selectedTicketOption, setSelectedTicketOption] = useState("regular"); // "regular" or "promotion"

    const [payment, setPayment] = useState({
        paymentMethodId: 0,
        deliveryMethodId: 0,
        insurance: false
    })

    const [orderInsurancePrice, setOrderInsurancePrice] = useState(0);

    const [isAgb1Checked, setIsAgb1Checked] = useState(false);
    const [isAgb2Checked, setIsAgb2Checked] = useState(false);

    const isButtonFinishOrderDisabled = payment.paymentMethodId === 0 || payment.deliveryMethodId === 0 || !isAgb1Checked || !isAgb2Checked;


    const [submitError, setSubmitError] = useState("");

    const [token, setToken] = useState(sessionStorage.getItem("token"));


    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);
                setToken(res.data);
                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId)
                    getOrderInsurance(currentOrderId);
                } else {
                    navigate("/de/visitor/home");
                }

                setOrganizerId(res.data.organizerId)
                setTicketTypeId(res.data.ticketTypeVisitorId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        if (token && language) {
            requestResources();
        }
    }, [language, token]);

    useEffect(() => {
        if (token && ticketTypeId) {

            loadTicketType(ticketTypeId)
        }
    }, [token, ticketTypeId]);

    //add promocodes to page if already existing in order
    useEffect(() => {
        if (order && Array.isArray(order.tickets)) {
            const codes = [];
            order.tickets.forEach(ticket => {
                if (ticket.promotionCode && !codes.includes(ticket.promotionCode)) {
                    codes.push(ticket.promotionCode);
                }
            });
            // Only update state if codes are different
            if (codes.length > 0 && (codes.length !== addedPromotionCodes.length || !codes.every(c => addedPromotionCodes.includes(c)))) {
                setAddedPromotionCodes(codes);
                setShowPromotionInput(true); // Auto-expand if there are existing codes
                setSelectedTicketOption("promotion"); // Auto-select promotion option
            }
        }
    }, [order]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.checkOut);
            })
            .catch((error) => console.error(error.response.data));
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/de/visitor/home");
            }
        }
    }

    const getTicketTypeById = async (ticketTypeId) => {
        try {
            const res = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/de/visitor/home");
            }
        }
    }

    const getOrderInsurance = async (currentOrderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${currentOrderId}/Insurance`);
            setOrderInsurancePrice(res.data);
        } catch (error) {
            console.error(error);
        }
    }

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            return res.data;
        } catch (error) {
            console.error(error)
        }
    };

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            const bookedTickets = updatedOrder.tickets;

            // Booked Tickets
            const updatedTickets = await Promise.all(
                bookedTickets.map(async (ticket) => {
                    const ticketType = await getTicketTypeById(ticket.ticketTypeId);

                    const info = await getTicketTypeInfosByTicketTypeId(ticket.ticketTypeId);
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    return { ...ticket, ticketType: ticketType, info: ticketTypeInfo }
                })
            )

            let updatedPayment = { ...payment, deliveryMethodId: updatedOrder.deliveryMethodId, paymentMethodId: updatedOrder.paymentMethodId };

            updatedPayment.insurance = updatedOrder.totalInsuranceAmount > 0;

            setPayment(updatedPayment);
            setOrder(updatedOrder);
            setTickets(updatedTickets);
        }
        catch (error) {
            console.error(error);
        }
    }

    const loadTicketType = async (ticketTypeId) => {
        try {
            const updatedTicketType = await getTicketTypeById(ticketTypeId);

            const info = await getTicketTypeInfosByTicketTypeId(ticketTypeId);

            // sorting it according to the language
            const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

            if (updatedTicketType === null) {
                navigate("/de/visitor/home")
            }

            // Add ticketTypeInfo to updatedTicketType
            setTicketType({ ...updatedTicketType, ticketTypeInfo });
        }
        catch (error) {
            console.error(error);
        }
    }

    const changeDeliveryType = async (deliveryMethodId) => {
        await axios.put(
            `${baseUrl}/ShopBasket/Order/${orderId}/DeliveryMethod/${deliveryMethodId}`)
            .then(() => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const changePaymentType = (paymentMethodId) => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/${paymentMethodId}`)
            .then((res) => {
                loadOrder(orderId);
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const changePaymentTypeToFree = () => {
        axios
            .put(`${baseUrl}/ShopBasket/Order/${orderId}/PaymentType/5`)
            .then(async () => {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            });
    }

    const applyPromotionCode = () => {
        axios
            .put(
                `${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${promotionCode}`
            )
            .then(async (res) => {
                setPromotionError({
                    text: `${resources.PromocodeSuccess} (${promotionCode})`,
                    valid: true
                });

                setAddedPromotionCodes((current) => [...current, promotionCode]);
                await loadOrder(orderId);
            })
            .catch((error) => {
                setPromotionError({
                    text: resources.PromocodeError,
                    valid: false
                });
            });
    };

    const removePromotionCode = (code) => {

        axios
            .delete(
                `${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`
            )
            .then(async (res) => {

                setAddedPromotionCodes((current) =>
                    current.filter((item) => item !== code));

                setPromotionError({
                    text: "",
                    valid: false
                });

                await loadOrder(orderId);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const setOrderInsurance = async () => {
        await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(async () => {
                await loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    const removeOrderInsurance = async () => {
        await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Insurance`)
            .then(async () => {
                await loadOrder(orderId);
            }).catch((error) => {
                console.error(error);
            })
    }

    // validate that the order still exists before payment process
    const validateOrderStillExists = async () => {
        try {
            const latest = await getOrderByOrderId(orderId);
            if (!latest) return false;
            if (!latest?.id) return false;
            if (!Array.isArray(latest?.tickets) || latest.tickets.length === 0) return false;
            return true;
        } catch (e) {
            return false;
        }
    }

    const startDatatrans = () => {
        var baseRequestUrl = `https://datatrans.ticketino.com/Datatrans/${orderId}/DigitalSignature`;

        axios
            .get(baseRequestUrl)
            .then((res) => {
                let datatransFormId = "datatrans-" + new Date().getTime();
                var form =
                    "<form className='datatrans' id='" + datatransFormId + "'></form>";

                let container = document.getElementById("datatrans-form-placeholder");

                container.innerHTML += form;

                let element = document.getElementById(datatransFormId);

                // merchantId for testing
                // element.setAttribute("data-merchant-id", "1100004624");
                element.setAttribute("data-merchant-id", res.data.merchantId);
                element.setAttribute("data-amount", res.data.amount);
                element.setAttribute("data-currency", res.data.currency);
                element.setAttribute("data-refno", res.data.referenceNumber);
                element.setAttribute("data-reqType", res.data.reqType);
                element.setAttribute(
                    "data-upp-return-target",
                    res.data.uppReturnTarget
                );
                element.setAttribute("data-paymentMethod", res.data.paymentMethod);
                element.setAttribute("data-sign", res.data.digitalSignature);

                let domain = "https://" + window.location.host;

                let successUrl = domain + `/form/redirect/${language}/success/${orderId}`;
                let errorUrl = domain + `/form/redirect/${language}/error/${orderId}`;
                let cancelUrl = domain + `/form/redirect/${language}/cancel/${orderId}`;

                element.setAttribute("data-success-url", successUrl);
                element.setAttribute("data-error-url", errorUrl);
                element.setAttribute("data-cancel-url", cancelUrl);

                for (const key in res.data.userInfo) {
                    element.setAttribute(key, res.data.userInfo[key]);
                }

                for (const key in res.data.merchantSpecificParameters) {
                    element.setAttribute(key, res.data.merchantSpecificParameters[key]);
                }

                // start datatrans -> call the payment form
                window.Datatrans.startPayment({
                    form: "#" + datatransFormId,
                });
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const onSubmit = async () => {
        setSubmitError("");

        const exists = await validateOrderStillExists();
        if (!exists) {
            setSubmitError(resources?.OrderExpiredMessage || "Your reservation is no longer available. Please start again.");
            return;
        }

        if (order?.totalPrice > 0) {
            let dataTransProviders = [1, 7, 8, 9, 10, 14];

            let datatransProvider = dataTransProviders.findIndex((d) => d === payment.paymentMethodId) !== -1

            if (datatransProvider) {
                startDatatrans();
            } else {
                await confirmShopbasketByOrderId(orderId);
                navigate(`/${language}/confirmation/${orderId}`);
            }
        } else {
            changePaymentTypeToFree();
        }
    }

    const mapTickets = () => {
        let ticketsSorted = [];

        if (tickets && tickets.length > 0) {
            ticketsSorted = [...tickets].sort((a, b) => a.id - b.id);
        }

        return (
            tickets &&
            tickets.length > 0 &&
            ticketsSorted.map((tt, index) => (
                <div key={index}>
                    <div className="row pt-2 pb-2">
                        <div className="col-md-8 col-8">
                            <label>{tt.info?.name}</label>
                        </div>
                        <div className="col-md-4 col-4 text-end">
                            <label>{tt.ticketType?.currency} {tt.price.toFixed(2)}</label>
                        </div>
                    </div>
                </div>
            ))
        );
    }

    const mapInsurance = () => {
        return (
            <div>
                <div className="row pt-2 pb-2">
                    <div className="col-md-10 col-8">
                        <label>{resources.TicketInsurance}</label>
                    </div>
                    <div className="col-md-2 col-4 text-end">
                        <label>
                            {order.currency + " " + order.totalInsuranceAmount.toFixed(2)}
                        </label>
                    </div>
                </div>
            </div>
        )
    }

    const mapExtraCosts = () => {
        return (
            <div>
                <div className="row pt-2 pb-1">
                    <div className="col-md-8 col-8">
                        <label>{resources.DeliveryCosts}</label>
                    </div>
                    <div className="col-md-4 col-4 text-end">
                        <label>{order.currency + " " + order?.deliverPaymentFee.toFixed(2)}</label>
                    </div>
                </div>
            </div>
        )
    }

    const mapAddedPromotionCodes = () => {
        return (
            <div>
                {addedPromotionCodes.map((code, index) => (
                    <div className="row" key={index}>
                        <div className="col-md-6 text-success">
                            {code} (Promotion code)
                        </div>
                        <div className="col-md-6 text-success text-end">
                            <button className="blank-button" onClick={() => removePromotionCode(code)}>({resources?._Delete})</button>
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const togglePromotionInput = () => {
        if (selectedTicketOption === "promotion") {
            // If already selected, deselect and go back to regular
            setSelectedTicketOption("regular");
            setShowPromotionInput(false);
        } else {
            // Select promotion option
            setSelectedTicketOption("promotion");
            setShowPromotionInput(true);
        }
    };

    const selectRegularTicket = () => {
        setSelectedTicketOption("regular");
        setShowPromotionInput(false);
    };

    return (
        <>
            <div id="datatrans-form-placeholder"></div>
            <div className="page-container">
                <Header language={language} />

                {/* Only render the rest of the page if ticketType is loaded and has ticketTypeInfo */}
                {ticketType && ticketType.ticketTypeInfo ? (
                    <>
                        <div className="container wrapper-small">
                            <div className="row mt-2">
                                <div className="col-md-12">
                                    <span className="text-title d-block">{resources?.EventName}</span>
                                    <span className="text-subtitle d-block">{resources?.VisitorTitle}</span>
                                </div>
                            </div>

                            {/* Ticket Type - regular */}
                            <div className="row mt-4" onClick={selectRegularTicket} style={{ cursor: 'pointer' }}>
                                <div className="col-md-4">
                                    {selectedTicketOption === "regular" ? (
                                        <>
                                            <i className="bi bi-check-circle me-2"></i>
                                            <span>{ticketType?.ticketTypeInfo?.name}</span>
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-circle me-2"></i>
                                            <span>{ticketType?.ticketTypeInfo?.name}</span>
                                        </>
                                    )}
                                </div>
                                <div className="col-md-4">
                                    {ticketType?.currency} {ticketType?.price}
                                </div>
                            </div>

                            {/* Ticket Type - promocode */}
                            <div className="row mt-4" onClick={togglePromotionInput} style={{ cursor: 'pointer' }}>
                                <div className="col-md-4">
                                    {selectedTicketOption === "promotion" ? (
                                        <>
                                            <i className="bi bi-check-circle me-2"></i>
                                            <span>{resources?.VisitorTicketWithPromotion}</span>
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-circle me-2"></i>
                                            <span>{resources?.VisitorTicketWithPromotion}</span>
                                        </>
                                    )}
                                </div>

                                {addedPromotionCodes.length > 0 && selectedTicketOption === "promotion" && (
                                    <div className="col-md-4 fw-bold">
                                        CHF {order?.total}
                                    </div>
                                )}
                            </div>

                            {/* promocode input - only show when promotion option is selected */}
                            {showPromotionInput && selectedTicketOption === "promotion" && (
                                <>
                                    <div className="row mt-5 mb-2">
                                        <div className="col-md-12">
                                            {resources?.PromocodeRedeem}
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6">
                                            <input
                                                id="inputCode"
                                                type="text"
                                                name="promotionCode"
                                                className="form-control"
                                                value={promotionCode}
                                                onChange={(e) => setPromotionCode(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <button
                                                style={{ height: "35px" }}
                                                className="btn button-custom mt-1"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    applyPromotionCode();
                                                }}
                                                disabled={promotionCode === ""}
                                            >
                                                {resources?._Redeem}
                                            </button>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {!promotionError.valid ? <p className="text-danger">
                                                {promotionError.text}
                                            </p> :
                                                <p className="text-success">
                                                    {promotionError.text}
                                                </p>}
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        {/* fullwidth background container */}
                        <div className="mt-4 fullwidth-bg-container">
                            <div className="container wrapper-small">

                                {/* delivery method */}
                                <div className="row mt-4 mb-2">
                                    <div className="col-md-12">
                                        {resources?.DeliveryOption}
                                    </div>
                                </div>

                                <div className="white-container" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                    <span onClick={() => changeDeliveryType(1)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                        {payment.deliveryMethodId === 1 ? (
                                            <i className="bi bi-check-circle me-2"></i>
                                        ) : (
                                            <i className="bi bi-circle me-2"></i>
                                        )}
                                    </span>
                                    <input
                                        className="form-check-input d-none"
                                        type="radio"
                                        name="deliveryMethod"
                                        id="printAtHome"
                                        checked={payment.deliveryMethodId === 1}
                                        onChange={() => changeDeliveryType(1)}
                                    />
                                    <label
                                        className="d-inline"
                                        htmlFor="printAtHome"
                                        style={{ cursor: 'pointer', marginBottom: 0 }}
                                    >
                                        <span>{resources.PrintAtHome}</span>
                                        <p className="text-secondary mb-0">
                                            {resources.PrintAtHomeDescription}
                                        </p>
                                    </label>
                                </div>

                                {/* payment methods */}
                                {order && order?.total > 0 &&
                                    <>
                                        <div className="row mt-4 mb-2">
                                            <div className="col-md-12">
                                                {resources?.PaymentOption}
                                            </div>
                                        </div>

                                        <div className="white-container">

                                            {/* mastercard */}
                                            <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <span onClick={() => changePaymentType(1)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                                    {payment.paymentMethodId === 1 ? (
                                                        <i className="bi bi-check-circle me-2"></i>
                                                    ) : (
                                                        <i className="bi bi-circle me-2"></i>
                                                    )}
                                                </span>
                                                <input
                                                    className="form-check-input d-none"
                                                    type="radio"
                                                    name="paymentMethods"
                                                    id="mastercard"
                                                    checked={payment.paymentMethodId === 1}
                                                    onChange={() => changePaymentType(1)}
                                                />
                                                <label
                                                    className="d-inline"
                                                    htmlFor="mastercard"
                                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                                >
                                                    <span>{resources.MasterCard}</span>
                                                    <p className="text-secondary mb-0">
                                                        {resources.MasterCardDesc}
                                                    </p>
                                                </label>
                                            </div>

                                            {/* visa */}
                                            <div className="mt-2" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <span onClick={() => changePaymentType(7)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                                    {payment.paymentMethodId === 7 ? (
                                                        <i className="bi bi-check-circle me-2"></i>
                                                    ) : (
                                                        <i className="bi bi-circle me-2"></i>
                                                    )}
                                                </span>
                                                <input
                                                    className="form-check-input d-none"
                                                    type="radio"
                                                    name="paymentMethods"
                                                    id="visa"
                                                    checked={payment.paymentMethodId === 7}
                                                    onChange={() => changePaymentType(7)}
                                                />
                                                <label
                                                    className="d-inline"
                                                    htmlFor="visa"
                                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                                >
                                                    <span>{resources.Visa}</span>
                                                    <p className="text-secondary mb-0">
                                                        {resources.VisaDesc}
                                                    </p>
                                                </label>
                                            </div>

                                            {/* amex */}
                                            <div className="mt-2" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <span onClick={() => changePaymentType(8)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                                    {payment.paymentMethodId === 8 ? (
                                                        <i className="bi bi-check-circle me-2"></i>
                                                    ) : (
                                                        <i className="bi bi-circle me-2"></i>
                                                    )}
                                                </span>
                                                <input
                                                    className="form-check-input d-none"
                                                    type="radio"
                                                    name="paymentMethods"
                                                    id="amex"
                                                    checked={payment.paymentMethodId === 8}
                                                    onChange={() => changePaymentType(8)}
                                                />
                                                <label
                                                    className="d-inline"
                                                    htmlFor="amex"
                                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                                >
                                                    <span>{resources.AmericanExpress}</span>
                                                    <p className="text-secondary mb-0">
                                                        {resources.AmericanExpressDesc}
                                                    </p>
                                                </label>
                                            </div>

                                            {/* postfinance */}
                                            <div className="mt-2" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <span onClick={() => changePaymentType(9)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                                    {payment.paymentMethodId === 9 ? (
                                                        <i className="bi bi-check-circle me-2"></i>
                                                    ) : (
                                                        <i className="bi bi-circle me-2"></i>
                                                    )}
                                                </span>
                                                <input
                                                    className="form-check-input d-none"
                                                    type="radio"
                                                    name="paymentMethods"
                                                    id="postfinance"
                                                    checked={payment.paymentMethodId === 9}
                                                    onChange={() => changePaymentType(9)}
                                                />
                                                <label
                                                    className="d-inline"
                                                    htmlFor="postfinance"
                                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                                >
                                                    <span>{resources.PostFinance}</span>
                                                    <p className="text-secondary mb-0">
                                                        {resources.PostFinanceDesc}
                                                    </p>
                                                </label>
                                            </div>

                                            {/* twint */}
                                            <div className="mt-2" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                <span onClick={() => changePaymentType(14)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                                    {payment.paymentMethodId === 14 ? (
                                                        <i className="bi bi-check-circle me-2"></i>
                                                    ) : (
                                                        <i className="bi bi-circle me-2"></i>
                                                    )}
                                                </span>
                                                <input
                                                    className="form-check-input d-none"
                                                    type="radio"
                                                    name="paymentMethods"
                                                    id="twint"
                                                    checked={payment.paymentMethodId === 14}
                                                    onChange={() => changePaymentType(14)}
                                                />
                                                <label
                                                    className="d-inline"
                                                    htmlFor="twint"
                                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                                >
                                                    <span>{resources.Twint}</span>
                                                    <p className="text-secondary mb-0">
                                                        {resources.TwintDesc}
                                                    </p>
                                                </label>
                                            </div>

                                            {/* invoice */}
                                            {/*<div className="mt-2" style={{ display: 'flex', alignItems: 'flex-start' }}>*/}
                                            {/*    <span onClick={() => changePaymentType(2)} style={{ cursor: 'pointer', marginTop: 3 }}>*/}
                                            {/*        {payment.paymentMethodId === 2 ? (*/}
                                            {/*            <i className="bi bi-check-circle me-2"></i>*/}
                                            {/*        ) : (*/}
                                            {/*            <i className="bi bi-circle me-2"></i>*/}
                                            {/*        )}*/}
                                            {/*    </span>*/}
                                            {/*    <input*/}
                                            {/*        className="form-check-input d-none"*/}
                                            {/*        type="radio"*/}
                                            {/*        name="paymentMethods"*/}
                                            {/*        id="invoice"*/}
                                            {/*        checked={payment.paymentMethodId === 2}*/}
                                            {/*        onChange={() => changePaymentType(2)}*/}
                                            {/*    />*/}
                                            {/*    <label*/}
                                            {/*        className="d-inline"*/}
                                            {/*        htmlFor="invoice"*/}
                                            {/*        style={{ cursor: 'pointer', marginBottom: 0 }}*/}
                                            {/*    >*/}
                                            {/*        <span>{resources.PaymmentInvoice}</span>*/}
                                            {/*        <p className="text-secondary mb-0">*/}
                                            {/*            {resources.PaymentSmallFee}*/}
                                            {/*        </p>*/}
                                            {/*    </label>*/}
                                            {/*</div>*/}
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        <div className="container wrapper-small">

                            {/* Summary */}
                            <div className="row mt-5">
                                <div className="col-md-12">
                                    {resources?.Summary}
                                </div>
                            </div>

                            <div className="row summary-container">
                                <div className="col-md-12">
                                    {mapTickets()}
                                    {payment.insurance && mapInsurance()}
                                    {order.deliverPaymentFee > 0 && mapExtraCosts()}
                                    {mapAddedPromotionCodes()}
                                    <hr className="custom-hr"></hr>
                                    <div className="row mb-3">
                                        <div className="col-md-8 col-8">
                                            <label className="fw-bold">
                                                {resources.Total}
                                            </label>
                                        </div>
                                        <div className="col-md-4 col-4 text-end">
                                            <label>
                                                {order.currency} {order.totalPrice?.toFixed(2)}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* insurance */}
                            <div className="font-14px mt-5" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <span
                                    onClick={() => {
                                        if (!payment.insurance) {
                                            setOrderInsurance();
                                        } else {
                                            removeOrderInsurance();
                                        }
                                    }}
                                    style={{ cursor: 'pointer', marginTop: 3 }}
                                >
                                    {payment.insurance ? (
                                        <i className="bi bi-check-square me-2"></i>
                                    ) : (
                                        <i className="bi bi-square me-2"></i>
                                    )}
                                </span>
                                <input
                                    className="form-check-input d-none"
                                    type="checkbox"
                                    id="insurance"
                                    checked={payment.insurance}
                                    onChange={(e) => {
                                        if (e.target.checked) {
                                            setOrderInsurance();
                                        } else {
                                            removeOrderInsurance();
                                        }
                                    }}
                                />
                                <label
                                    className="d-inline ms-2"
                                    htmlFor="insurance"
                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                >
                                    {parse(
                                        (orderInsurancePrice === 0
                                            ? resources.TicketInsuranceDescGeneric
                                            : (resources.TicketInsuranceDesc ?? "").replace("{@InsurancePrice}", orderInsurancePrice.toFixed(2))
                                        ) ?? ""
                                    )}
                                </label>
                            </div>

                            {/* AGBs / Terms and Conditions */}
                            <div className="font-14px mt-3" style={{ display: 'flex', alignItems: 'flex-start' }}>
                                <span onClick={() => setIsAgb1Checked(!isAgb1Checked)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                    {isAgb1Checked ? (
                                        <i className="bi bi-check-square me-2"></i>
                                    ) : (
                                        <i className="bi bi-square me-2"></i>
                                    )}
                                </span>
                                <input
                                    className="form-check-input d-none"
                                    type="checkbox"
                                    id="agb1Checkbox"
                                    checked={isAgb1Checked}
                                    onChange={() => setIsAgb1Checked(!isAgb1Checked)}
                                />
                                <label
                                    className="d-inline ms-2"
                                    htmlFor="agb1Checkbox"
                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                >
                                    <span dangerouslySetInnerHTML={{ __html: resources?.VisitorAgb1 }}></span>
                                </label>
                            </div>

                            <div className="font-14px mt-3" style={{ display: 'flex', alignItems: 'flex-start'}}>
                                <span onClick={() => setIsAgb2Checked(!isAgb2Checked)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                    {isAgb2Checked ? (
                                        <i className="bi bi-check-square me-2"></i>
                                    ) : (
                                        <i className="bi bi-square me-2"></i>
                                    )}
                                </span>
                                <input
                                    className="form-check-input d-none"
                                    type="checkbox"
                                    id="agb2Checkbox"
                                    checked={isAgb2Checked}
                                    onChange={() => setIsAgb2Checked(!isAgb2Checked)}
                                />
                                <label
                                    className="d-inline ms-2"
                                    htmlFor="agb2Checkbox"
                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                >
                                    <span dangerouslySetInnerHTML={{ __html: resources?.VisitorAgb2 }}></span>
                                </label>
                            </div>

                            {/* error message */}
                            {submitError && (
                                <div className="alert error mt-4" role="alert" style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconAlert style={{ fill: 'white', marginRight: '8px', flexShrink: 0 }} />
                                    <span>{submitError}</span>
                                </div>
                            )}

                            {/* button finish order */}
                            <div className="row mt-4">
                                <div className="col-md-6">
                                    <button className="btn button-custom" onClick={() => navigate(-1)}>{resources?._Back}</button>
                                </div>
                                <div className="col-md-6 text-end">
                                    <button className="btn button-custom" onClick={() => onSubmit()} disabled={isButtonFinishOrderDisabled}>{resources?._Buy}</button>
                                </div>
                            </div>

                            <p className="mt-4">
                                <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                            </p>
                        </div>
                    </>
                ) : null}
            </div>
        </>
    )
}

export default Visitor_Step40_Checkout